/**
 * Streak calculation — a pure function extracted from the prototype.
 * Given the set of dates (YYYY-MM-DD) on which the user completed their plan,
 * returns the current consecutive-day streak ending today (or yesterday, so a
 * streak isn't "broken" until a full day is missed).
 */
export function currentStreak(completedDates: Iterable<string>, today: string): number {
  const done = new Set(completedDates);
  if (done.size === 0) return 0;

  // Walk backwards from today. Allow the streak to "hang" if today isn't done
  // yet but yesterday was.
  let cursor = today;
  if (!done.has(cursor)) {
    cursor = addDays(cursor, -1);
    if (!done.has(cursor)) return 0;
  }

  let streak = 0;
  while (done.has(cursor)) {
    streak += 1;
    cursor = addDays(cursor, -1);
  }
  return streak;
}

/** Add (or subtract) whole days to a YYYY-MM-DD string. Calendar-safe (UTC). */
export function addDays(isoDate: string, delta: number): string {
  const [y, m, d] = isoDate.split("-").map(Number) as [number, number, number];
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + delta);
  return dt.toISOString().slice(0, 10);
}
